
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Bandratopunecabs() {



    const cardData =
    {
        keyword: 'Bandra to Pune Cab',
        heading: 'Meghana Cab : Bandra to Pune Cab',
        headingDescription: 'Meghana Cab offers Bandra to Pune Cab services, making intercity travel easy, comfortable, and punctual. Whether you are traveling for work, a family visit, or a weekend getaway, our clean and well-maintained cabs with experienced drivers ensure a smooth and relaxed ride. With options to choose your preferred vehicle, enjoy fixed transparent fares, timely pickups, and 24/7 customer support. Book your Bandra to Pune Cab with Meghana Cab and experience seamless travel with unmatched reliability.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An 8th-century rock-cut temple located in the heart of the city, Pataleshwar is dedicated to Lord Shiva. It features a circular Nandi mandapa and intricately carved pillars. The temple is a peaceful heritage site amidst urban surroundings."
  },
    {
    "title": "Sinhagad Fort",
    "description": "Located about 30 km from Pune, this fort is a popular destination for trekking and history lovers. It was the site of the Battle of Sinhagad in 1670, and offers panoramic views of the surrounding valleys. Visitors also enjoy local food like pithla bhakri at the summit."
  },
  {
    "title": "Shaniwar Wada",
    "description": "A historical fortification built in 1732, Shaniwar Wada was once the seat of the Peshwas of the Maratha Empire. The grand gateway, expansive ruins, and the evening light and sound show depicting Maratha history make it one of Pune’s most important landmarks for cultural and heritage tourism."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892, the Aga Khan Palace holds deep significance in India’s freedom struggle. It served as a prison for Mahatma Gandhi and his wife Kasturba Gandhi. The palace is surrounded by lush gardens and houses a museum with Gandhian artifacts and personal belongings."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This museum showcases over 20,000 artifacts including musical instruments, traditional utensils, sculptures, and textiles. It offers a glimpse into India’s rich artistic and cultural history, particularly from Maharashtra."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Situated in Koregaon Park, this globally renowned spiritual retreat attracts visitors interested in meditation, wellness, and holistic healing. The campus offers a tranquil setting with daily meditation sessions and therapy workshops."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend getaway for Pune residents, this dam provides water to the city and is surrounded by scenic views of hills and greenery. It's ideal for picnics, photography, and relaxing by the water during early mornings or evenings."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by a Japanese garden in Okayama, this beautifully landscaped public park features manicured lawns, flowing streams, and charming bridges. It's a favorite spot for family outings and peaceful strolls."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shivaji Maharaj’s father, Shahaji, this reconstructed palace commemorates the early life of Chhatrapati Shivaji Maharaj. It houses paintings, artifacts, and replicas reflecting Maratha heritage."
  },
  {
    "title": "Fergusson College Road",
    "description": "Known for its lively ambiance and youthful vibe, this road is a hub for students, with a wide variety of cafes, bookstores, fashion outlets, and street food. It reflects the cultural vibrancy and modern spirit of Pune."
  }
],

"services": [
    {
        "name": "Bandra to Pune Cab Booking",
        "description": "Book your Bandra to Pune cab with Meghana Cab for a reliable, comfortable, and safe travel experience. Our online booking platform allows for instant confirmations, and we offer a wide range of vehicles to suit your needs—perfect for personal or business travel."
    },
    {
        "name": "One Way Taxi Bandra to Pune",
        "description": "Meghana Cab offers one-way taxi service from Bandra to Pune at competitive prices. Whether you're relocating, visiting family, or traveling for work, our clean cabs and courteous drivers ensure a smooth ride with doorstep pickup and drop-off."
    },
    {
        "name": "Cab Hire Bandra West to Pune",
        "description": "Hire a cab from Bandra West to Pune effortlessly with Meghana Cab. Choose from sedans, SUVs, or premium cars and enjoy a personalized and comfortable journey tailored to your schedule and travel requirements."
    },
    {
        "name": "SUV Taxi Bandra to Pune",
        "description": "Travel in style and space with our SUV taxi from Bandra to Pune. Ideal for groups and families, our SUVs offer ample luggage space, comfort, and air-conditioning for long-distance travel. Book online for hassle-free service."
    },
    {
        "name": "AC Sedan Bandra to Pune",
        "description": "Choose our AC sedan cab for a quiet, smooth, and comfortable journey from Bandra to Pune. Perfect for solo travelers or small families, our sedans provide affordability without compromising comfort and cleanliness."
    },
    {
        "name": "Affordable Cab Service Bandra to Pune",
        "description": "Meghana Cab brings you budget-friendly cab services from Bandra to Pune. Enjoy fixed and transparent fares, professionally maintained vehicles, and trained drivers for a worry-free travel experience that fits your budget."
    },
    {
        "name": "24-Hour Cab Bandra to Pune",
        "description": "Travel any time of the day or night with our 24-hour Bandra to Pune cab service. Early morning airport drop? Late-night intercity ride? We're available round-the-clock to serve your transportation needs."
    },
    {
        "name": "Private Car Bandra to Pune",
        "description": "Enjoy privacy and flexibility with our private car hire service from Bandra to Pune. Our chauffeur-driven cars ensure safety, comfort, and convenience, making them ideal for business travelers or couples seeking a quiet ride."
    },
    {
        "name": "Round Trip Cab Bandra to Pune",
        "description": "Book a round trip cab from Bandra to Pune and back with Meghana Cab. Save on travel costs and enjoy the convenience of having the same reliable vehicle and driver for your return journey."
    },
    {
        "name": "Mumbai Bandra to Pune Taxi Fare",
        "description": "Looking for Bandra to Pune taxi fare details? Meghana Cab offers competitive and all-inclusive pricing with no hidden charges. Get fare estimates online or via customer support before you book."
    },
    {
        "name": "Bandra to Pune Driver Cabs",
        "description": "Our chauffeur-driven cabs from Bandra to Pune are perfect for those who want a stress-free travel experience. Trained drivers ensure a smooth, safe, and timely ride across the Mumbai–Pune route."
    },
    {
        "name": "Book Bandra to Pune Ride Online",
        "description": "Instantly book your Bandra to Pune ride online through Meghana Cab. Choose your preferred vehicle, time slot, and get confirmation in seconds. Enjoy seamless travel with professional service throughout the journey."
    },
    {
        "name": "Bandra East to Pune Taxi",
        "description": "Meghana Cab offers prompt taxi pickup from Bandra East to Pune. Whether you're heading to work, a family event, or a weekend retreat, our reliable cab service ensures timely pickup and comfortable travel."
    },
    {
        "name": "Business Cab Hire Bandra to Pune",
        "description": "Need a professional cab service for corporate travel? Our business cabs from Bandra to Pune come with trained drivers, clean AC cars, and on-time service—ideal for meetings, airport transfers, or intercity commutes."
    },
    {
        "name": "Weekend Trip Cab Bandra to Pune",
        "description": "Planning a weekend getaway to Pune from Bandra? Book a cab with Meghana Cab for a comfortable round trip. Choose from a variety of vehicles including sedans and SUVs with flexible return scheduling."
    }
],

"tableData": [
    ["Bandra to Pune Cab Booking", "One Way Taxi Bandra to Pune"],
    ["Cab Hire Bandra West to Pune", "SUV Taxi Bandra to Pune"],
    ["AC Sedan Bandra to Pune", "Affordable Cab Service Bandra to Pune"],
    ["24-Hour Cab Bandra to Pune", "Private Car Bandra to Pune"],
    ["Round Trip Cab Bandra to Pune", "Mumbai Bandra to Pune Taxi Fare"],
    ["Bandra to Pune Driver Cabs", "Book Bandra to Pune Ride Online"],
    ["Bandra East to Pune Taxi", "Business Cab Hire Bandra to Pune"],
    ["Weekend Trip Cab Bandra to Pune", ""]
],











"whychoose": [
    {
        "WhyChooseheading": "Comfortable Bandra to Pune Cab Service",
        "WhyChoosedescription": "Meghana Cab provides a reliable and comfortable cab service from Bandra to Pune, perfect for daily commuters, weekend travelers, or business professionals who value convenience, safety, and punctuality."
    },
    {
        "WhyChooseheading": "Timely Pickup from Any Location in Bandra",
        "WhyChoosedescription": "We offer prompt pickup from your home, hotel, or office in Bandra. No delays or waiting—our drivers arrive on time and ensure a smooth start to your journey toward Pune."
    },
    {
        "WhyChooseheading": "Clean and Well-Maintained Vehicles",
        "WhyChoosedescription": "Travel in air-conditioned, sanitized, and spacious cabs. Whether you choose a sedan, SUV, or premium vehicle, each ride ensures maximum comfort on the Bandra to Pune route."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Route Expertise",
        "WhyChoosedescription": "Our trained drivers are highly familiar with Mumbai’s traffic and the Pune Expressway. They ensure a safe, efficient, and stress-free journey regardless of time or weather."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Enjoy competitive rates with no hidden costs. Our clear pricing model means you always know what you’re paying for, giving you excellent value for your money."
    },
    {
        "WhyChooseheading": "Flexible One-Way and Round Trip Options",
        "WhyChoosedescription": "Whether you need a one-way transfer or a round trip from Bandra to Pune, Meghana Cab offers flexible options to suit your travel schedule and budget."
    },
    {
        "WhyChooseheading": "24/7 Service for All Travel Timings",
        "WhyChoosedescription": "Late-night airport arrivals? Early-morning meetings in Pune? Our Bandra to Pune cab service operates 24/7 to ensure we’re always available when you need us most."
    },
    {
        "WhyChooseheading": "Easy Booking and Responsive Support",
        "WhyChoosedescription": "Book your cab easily via our website, app, or phone call. Our customer support is always available to assist you with bookings, modifications, or any travel queries."
    }
]







































    }

const faqData = [
    {
        question: "How can I book a cab from Bandra to Pune with Meghana Cab?",
        answer: "You can book a Bandra to Pune cab by calling Meghana Cab at +91 9075462128 or through our website for easy booking."
    },
    {
        question: "What types of vehicles are available for Bandra to Pune trips?",
        answer: "We offer sedans, SUVs, and tempo travellers to suit your travel group and comfort preferences."
    },
    {
        question: "Are Meghana Cab drivers experienced with Bandra to Pune routes?",
        answer: "Yes, our drivers know the best routes between Bandra and Pune ensuring a safe and timely journey."
    },
    {
        question: "Can I book a one-way or round-trip cab from Bandra to Pune?",
        answer: "Yes, Meghana Cab provides both one-way and round-trip options based on your travel needs."
    },
    {
        question: "What is included in the Bandra to Pune cab fare?",
        answer: "The fare includes driver charges, fuel, and vehicle maintenance. Additional charges such as tolls and parking may apply."
    },
    {
        question: "Is Meghana Cab available 24/7 for Bandra to Pune bookings?",
        answer: "Yes, our services operate round-the-clock to accommodate your schedule."
    },
    {
        question: "Can I book a cab for a large group from Bandra to Pune?",
        answer: "Yes, we offer tempo travellers and SUVs suitable for larger groups."
    },
    {
        question: "Are the vehicles clean and sanitized for travel?",
        answer: "All vehicles are regularly cleaned and sanitized for your safety and comfort."
    },
    {
        question: "What payment methods are accepted for Bandra to Pune cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash."
    },
    {
        question: "How can I contact Meghana Cab for Bandra to Pune cab services?",
        answer: "Call Meghana Cab at +91 9075462128 to book or inquire about Bandra to Pune cab services."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Sameer Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab provided a smooth and comfortable Bandra to Pune cab service. The driver was professional.”',
    },
    {
        name: 'Ms. Priya Deshmukh',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Highly recommend Meghana Cab for Bandra to Pune travel. Reliable and comfortable.”',
    },
];

































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bandra to Pune Cab",
  "image": "https://www.meghanacabs.com/assets/images/bandra-to-pune-cab.jpg",
  "description": "Book Bandra to Pune cab with Meghana Cabs for a reliable and affordable journey. Choose one-way or round trip in AC sedans, SUVs, or chauffeur-driven cars with 24/7 availability.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5791"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1650",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/bandra-to-pune-cab"
  }
};







    return (
        <div>

<Helmet>
  <title>Bandra to Pune Cab | One Way & Round Trip Taxi Booking</title>
  <meta 
    name="description" 
    content="Book Bandra to Pune cab with Meghana Cabs for a reliable and affordable journey. Choose one-way or round trip in AC sedans, SUVs, or chauffeur-driven cars with 24/7 availability." 
  />
  <meta 
    name="keywords" 
    content="Bandra to Pune Cab Booking, One Way Taxi Bandra to Pune, Cab Hire Bandra West to Pune, SUV Taxi Bandra to Pune, AC Sedan Bandra to Pune, Affordable Cab Service Bandra to Pune, 24-Hour Cab Bandra to Pune, Private Car Bandra to Pune, Round Trip Cab Bandra to Pune, Mumbai Bandra to Pune Taxi Fare, Bandra to Pune Driver Cabs, Book Bandra to Pune Ride Online, Bandra East to Pune Taxi, Business Cab Hire Bandra to Pune, Weekend Trip Cab Bandra to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/30.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bandratopunecabs;